export type CalculateTourCo2 = {
  global: CalculateTourGlobalCo2;
  general: CalculateTourGeneralCo2;
  ontour: CalculateTourOntourCo2;
};

export type CalculateTourGlobalCo2 = {
  score: number;
};

export type CalculateTourGeneralCo2 = {
  score: number;
  sections: {
    CREATION: {
      score: number;
      categories: {
        SCENOGRAPHY: { score: number };
        TEAM_MOBILITY: { score: number };
        REPEATS_AND_MATERIAL: { score: number };
      };
    };
    MANAGEMENT: {
      score: number;
      categories: {
        TEAM_MOBILITY: { score: number };
        CATERING: { score: number };
        OFFICE: { score: number };
      };
    };
    COMMUNICATION: {
      score: number;
      categories: {
        MERCHANDISING: { score: number };
        ADVERTISING: { score: number };
        VIDEO_AND_DIGITAL: { score: number };
        TICKETING: { score: number };
      };
    };
  };
};

export type CalculateTourOntourCo2 = {
  score: number;
  bySequence: {
    [sequenceId: number]: {
      score: number;
      events: number;
      travels: number;
      variousCost: CalculateTourCo2VariousCost;
    };
  };
  byTourEvent: {
    [tourEventId: number]: {
      score: number;
    };
  };
  byTourTravel: {
    [tourTravelId: number]: {
      score: number;
    };
  };
};

type CalculateTourCo2VariousCost = {
  score: number;
  sectors: {
    artists: {
      categories: {
        accommodation: { score: number };
        catering: { score: number };
        equipment: { score: number };
      };
    };
  };
};

export const EMPTY_CALCULATE_TOUR_CO2: CalculateTourCo2 = {
  global: {
    score: 0,
  },
  general: {
    score: 0,
    sections: {
      CREATION: {
        score: 0,
        categories: {
          SCENOGRAPHY: { score: 0 },
          TEAM_MOBILITY: { score: 0 },
          REPEATS_AND_MATERIAL: { score: 0 },
        },
      },
      MANAGEMENT: {
        score: 0,
        categories: {
          TEAM_MOBILITY: { score: 0 },
          CATERING: { score: 0 },
          OFFICE: { score: 0 },
        },
      },

      COMMUNICATION: {
        score: 0,
        categories: {
          MERCHANDISING: { score: 0 },
          ADVERTISING: { score: 0 },
          VIDEO_AND_DIGITAL: { score: 0 },
          TICKETING: { score: 0 },
        },
      },
    },
  },
  ontour: {
    score: 0,
    bySequence: {},
    byTourEvent: {},
    byTourTravel: {},
  },
};

export const EMPTY_CALCULATE_TOUR_CO2_VARIOUS_COST: CalculateTourCo2VariousCost =
  {
    score: 0,
    sectors: {
      artists: {
        categories: {
          accommodation: { score: 0 },
          catering: { score: 0 },
          equipment: { score: 0 },
        },
      },
    },
  };
